import { combineReducers } from "redux";
import isSidebarReducer from "./features/sidebar";
import userReducer from "./features/authSlice";
import LoaderReducer from "./features/loader";
import takafulPrividerReducer from "./features/takafulProvider";
import serviceProviderReducer from "./features/serviceProvider";
import takafulBazaarUserReducer from "./features/userManagement";
import healthReducer from "./features/health";
import serviceReducer from "./features/services";
import healthOrderReducer from "./features/healthOrder";
import globalReducer from "./features/global";
import permission from "./features/permission";
import autoReducer from "./features/auto";
import partnerReducer from "./features/partner";
import autoOrderReducer from "./features/auto/autoOrder";
import bacOrganizationReducer from "./features/bacOrganizarion";
import bacPlanReducer from "./features/bacPlan";
import personalAccidentReducer from "./features/personalAccident";
import personalAccidentOrderReducer from "./features/personalAccidentOrder";
import houseHoldOrderReducer from "./features/houseHoldOrder";
import houseHoldReducer from "./features/houseHold";
import lifeReducer from "./features/life";
import lifeOrderReducer from "./features/lifeOrder";
import travelReducer from "./features/travel";
import travelOrderReducer from "./features/travelOrder";

export default combineReducers({
  isSidebar: isSidebarReducer,
  user: userReducer,
  loading: LoaderReducer,
  takafulProvider: takafulPrividerReducer,
  partner: partnerReducer,
  serviceProvider: serviceProviderReducer,
  takafulBazaarUser: takafulBazaarUserReducer,
  health: healthReducer,
  auto: autoReducer,
  service: serviceReducer,
  healthOrder: healthOrderReducer,
  autoOrder: autoOrderReducer,
  global: globalReducer,
  permission: permission,
  bacOrganization: bacOrganizationReducer,
  bacPlan: bacPlanReducer,
  personalAccident: personalAccidentReducer,
  personalAccidentOrder: personalAccidentOrderReducer,
  houseHoldOrder: houseHoldOrderReducer,
  houseHold: houseHoldReducer,
  life: lifeReducer,
  lifeOrder: lifeOrderReducer,
  travel: travelReducer,
  travelOrder: travelOrderReducer
});
